import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Signup = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Redirect to pricing page as we now use popups
        navigate('/pricing');
    }, [navigate]);

    return (
        <div className="flex items-center justify-center min-h-screen bg-theme-primary">
            <div className="text-center">
                <div className="animate-spin w-8 h-8 border-3 border-blue-500 border-t-transparent rounded-full mb-4 mx-auto"></div>
                <p className="text-theme-secondary">Redirecting to pricing...</p>
            </div>
        </div>
    );
};

export default Signup;
